import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { SystemEventTemplate, SystemEventTemplateForCreation, SystemEventTemplateForUpdate } from '../../interfaces/system_events/system-event-template';

@Injectable({
    providedIn: 'root'
})
export class SystemEventTemplatesRepositoryService {
    protected _baseLink: string;

    constructor(
        @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
        protected http: HttpClient,
        protected messageService: ToastrService) {
        this._baseLink = `${this.config.rootUrl}/SystemEventTemplates`;
    }

    private generateHeaders = () => {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        }
    }

    public getSystemEventTemplate = (systemEventTemplateID: string) => {
        return this.http.get<SystemEventTemplate>(`${this._baseLink}/${systemEventTemplateID}`, this.generateHeaders());
    }

    public getSystemEventTemplates = () => {
        return this.http.get<SystemEventTemplate[]>(`${this._baseLink}`, this.generateHeaders());
    }

    public createSystemEvent(newEventTemplate: SystemEventTemplateForCreation): Observable<SystemEventTemplate> {
        return this.http.post<SystemEventTemplate>(`${this._baseLink}`, newEventTemplate);
    }

    public updateSystemEvent(systemEventTemplateID: string, systemEventTemplate: SystemEventTemplateForUpdate): Observable<SystemEventTemplate> {
        return this.http.put<SystemEventTemplate>(`${this._baseLink}/${systemEventTemplateID}`, systemEventTemplate);
    }

    public deleteSystemEventTemplate = (systemEventTemplateID: string) => {
        return this.http.delete(`${this._baseLink}/${systemEventTemplateID}`, this.generateHeaders());
    }
}